import React, { useState } from 'react'
import { StyledPaper, StyledTabs } from '../fui/FuiStyles'
import { Tab } from '@material-ui/core'
import LicenseManagement from './LicenseManagement'
// import SplunkLicenseConfig from './SplunkLicenseConfig'

export default function LicensePage() {
  const [tabIndex, setTabIndex] = useState(0)  

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }
  
   const hideTMenu = () => {
    const alldiv = document.getElementsByClassName('table-menu');
    for (var i = 0, len = alldiv.length; i < len; i++) {
      alldiv[i].style["display"] = 'none';
    }
  };

  return (
    <div style={{padding:'0 10px'}} onClick={()=>hideTMenu()}>
      <StyledTabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        margin="0px"
      >
        <Tab label="License Management" />
        {/* <Tab label="Splunk License Config" /> */}
      </StyledTabs>
      <StyledPaper style={{ height: "80%", overflow: "hidden", overflowY:'auto',padding: '0 10px'}}>
        <div style={{minHeight:'calc(90vh - 100px)'}}>
          {tabIndex === 0 && <LicenseManagement />}
        </div>
        
        {/* {tabIndex === false && <SplunkLicenseConfig />} */}
      </StyledPaper>
    </div>
  )
}
